module.exports = __webpack_public_path__ + "img/tavakademi-desktop.9778ee27.jpg";